<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Total coupons"
                                type="gradient-red"
                                :sub-title="rows.length"
                                icon="ni ni-active-40"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Active coupons"
                                type="gradient-orange"
                                :sub-title="activeCoupons.length"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-10">
                                    <h4 class="font-weight-bold text-primary">Coupons</h4>
                                </div>
                                <div class="card-tools col-md-2">
                                    <button class="btn btn-success rounded-pill btn-sm" data-toggle="modal"
                                            data-target="#addCoupons" @click="newModal"> Add Coupon
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class=" table-responsive no-padding">
                            <vue-good-table
                                    :line-numbers="true"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                               enabled: true,
                               mode: 'pages',
                               perPage: 10
                             }"
                                    :search-options="{
                                enabled: true,
                                placeholder: 'Search this table',
                              }">
                                <template slot="table-row" slot-scope="props">
                                    <span v-if="props.column.field == 'created'">
                                        <small>{{moment(props.row.created_at).format('MMMM Do YYYY, h:mm:ss a')}}</small>
                                    </span>
                                    <span v-else-if="props.column.field == 'action'">
                                    <button type="button" class="btn btn-sm btn-primary btn-circle"
                                            @click="editCoupon(props.row)">
                                    <i class="fas fa-edit"></i>
                                </button>
                                        <!--                                <button type="button" class="btn btn-danger btn-sm btn-circle"-->
                                        <!--                                        @click="deleteCoupon(props.row.id)">-->
                                        <!--                                    <i class="fas fa-trash"></i>-->
                                        <!--                                </button>-->
                                </span>
                                    <span v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </span>
                                </template>
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>

            <!--BOOTSTRAP MODAL-->
            <div class="modal fade addCoupons-modal-lg" tabindex="-1" id="addCoupons" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 v-if="!isEdit">Add new Coupon</h4>
                            <h4 v-if="isEdit">Edit Coupon</h4>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <form autocomplete="off" @submit.prevent="addCoupon">
                                <div class="form-group">
                                    <label class="float-left">Code</label>
                                    <input v-model="form.code" type="text" class="form-control" placeholder="code">
                                    <small class="float-left" style="color: red" v-if="error && errors.code">{{
                                        errors.code[0]
                                        }}</small>
                                    <br>
                                </div>
                                <div class="form-group">
                                    <label class="float-left">Type</label>
                                    <select v-model="form.type" class="form-control">
                                        <option value="" selected>--Select Type--</option>
                                        <option value="fixed">Fixed</option>
                                        <option value="percent">Percent</option>
                                    </select>
                                    <small class="float-left" style="color: red" v-if="error && errors.type">{{
                                        errors.type[0]
                                        }}</small>
                                    <br>
                                </div>
                                <div class="form-group" v-if="form.type == 'percent'">
                                    <label class="float-left">Percentage-off</label>
                                    <input v-model="form.percent_off" type="number" class="form-control"
                                           placeholder="Percent off">
                                    <small class="float-left" style="color: red" v-if="error && errors.percent_off">{{
                                        errors.percent_off[0]
                                        }}</small><br>
                                </div>
                                <div class="form-group" v-if="form.type == 'fixed'">
                                    <label class="float-left">Discount Amount</label>
                                    <input v-model="form.discount_amount" type="number" class="form-control"
                                           placeholder="Amount">
                                    <small class="float-left" style="color: red" v-if="error && errors.discount_amount">{{
                                        errors.discount_amount[0]
                                        }}</small><br>
                                </div>
                                <div class="form-group">
                                    <label class="float-left">Status</label>
                                    <select v-model="form.status" class="form-control">
                                        <option value="" selected>--Select Status--</option>
                                        <option value="active">Activate</option>
                                        <option value="inactive">Deactivate</option>
                                    </select>
                                    <small class="float-left" style="color: red" v-if="error && errors.status">{{
                                        errors.status[0]
                                        }}</small><br>
                                </div>
                                <div class="form-group">
                                    <label class="float-left">Goods Worth Above</label>
                                    <input v-model="form.goods_worth" type="number" class="form-control"
                                           placeholder="Goods Worth">
                                    <small class="float-left" style="color: red" v-if="error && errors.goods_worth">{{
                                        errors.goods_worth[0]
                                        }}</small><br>
                                </div>


                                <hr>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal"
                                            @click="close">Close
                                    </button>
                                    <button v-if="!isEdit" type="submit"
                                            class="rounded-pill btn btn-outline-primary float-right">Add Coupon
                                    </button>
                                    <button v-if="isEdit" type="button"
                                            class=" rounded-pill btn btn-outline-primary float-right"
                                            @click="updateCoupon">Update
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vld-parent">
                <loading name="loader" :active.sync="isLoading"
                         :can-cancel="false"
                         :is-full-page="fullPage"></loading>
            </div>
        </div>
    </div>
</template>
<script>
    // Import component
    import Loading from 'vue-loading-overlay';
    // Import stylesheet
    import 'vue-loading-overlay/dist/vue-loading.css';

    let moment = require('moment');
    export default {
        name: 'tables',
        components: {
            Loading
        },
        data() {
            return {
                moment,
                isEdit: false,
                rows: [],
                columns: [
                    {
                        label: 'Code',
                        field: 'code',
                    },
                    {
                        label: 'Type',
                        field: 'type',
                    },
                    {
                        label: 'Amount(Ksh) Off',
                        field: 'value',
                    },
                    {
                        label: 'Percent(%) Off',
                        field: 'percent_off',
                    },
                    {
                        label: 'Status',
                        field: 'status',
                    },
                    {
                        label: 'Goods Above',
                        field: 'goods_worth',
                    },
                    {
                        label: 'Created On',
                        field: 'created',
                    },
                    {
                        label: 'Action',
                        field: 'action'
                    }
                ],
                isLoading: false,
                fullPage: true,
                errors: {},
                error: false,
                form: {
                    id: '',
                    code: '',
                    type: '',
                    percent_off: '',
                    discount_amount: '',
                    status: '',
                    goods_worth: ''
                }
            }
        },
        computed: {
            activeCoupons(){
                return this.rows.filter(m => m.status === 'active')
            }
        },
        methods: {
            deleteCoupon(id) {
                this.$swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.axios.delete('/admin/shopLocal/coupon/' + id).then(() => {
                            this.$swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                            this.getCoupons();
                        }).catch((error) => {
                            this.error = true;
                            this.errors = error.response.data.errors;
                        })
                    }
                })
            },
            updateCoupon() {
                this.isLoading = true;
                this.axios.put('/admin/shopLocal/coupon/' + this.form.id, this.form).then(() => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Coupon updated successfully'
                    });
                    this.isLoading = false;
                    $('#addCoupons').modal('hide');
                    this.form = {
                        id: '',
                        code: '',
                        type: '',
                        percent_off: '',
                        discount_amount: '',
                        status: '',
                        goods_worth: ''
                    };
                    this.getCoupons();
                }).catch((error) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = error.response.data.errors;
                })
            },
            editCoupon(coupon) {
                this.isEdit = true;
                this.form = {
                    id: coupon.id,
                    code: coupon.code,
                    type: coupon.type,
                    percent_off: coupon.percent_off,
                    discount_amount: coupon.value,
                    status: coupon.status,
                    goods_worth: coupon.goods_worth
                };
                $('#addCoupons').modal('show');
            },
            getCoupons() {
                try {
                    this.axios.get('/admin/shopLocal/coupon').then(({data}) => ([this.rows = data]));
                } catch (e) {
                    throw new Error(e);
                }

            },
            addCoupon() {
                this.isLoading = true;
                this.axios.post('/admin/shopLocal/coupon', this.form).then(() => {
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Coupon created successfully'
                    });
                    this.isLoading = false;
                    $('#addCoupons').modal('hide');
                    this.form = {
                        code: '',
                        type: '',
                        percent_off: '',
                        discount_amount: '',
                        status: '',
                        goods_worth: ''
                    };
                    this.getCoupons();
                }).catch((error) => {
                    this.isLoading = false;
                    this.error = true;
                    this.errors = error.response.data.errors;
                })
            },
            newModal() {
                this.form = {
                    id: '',
                    code: '',
                    type: '',
                    percent_off: '',
                    discount_amount: '',
                    status: '',
                    goods_worth: ''
                };
                this.isEdit = false;
                this.errors = {};
                $('#addCoupons').modal('show');
            },
            close() {
                $('#addCoupons').modal('hide');
            },
        },
        created() {
            this.getCoupons();
        }
    };
</script>
<style>
    .button1 {
        padding: 5px 10px;
        border-radius: 50px 50px 50px 50px;
        color: white;
        background-color: #4CAF50;
    }

    .form-control {
        /*border: 1px solid #ccc;*/
        display: block;
        width: 100%;
        height: 40px;
        padding: 0 15px;
        border-radius: 20px;
        font-family: Gotham, Arial, Helvetica Neue, Helvetica, sans-serif;
        background: none;
    }

    .form-control:focus {
        border: 1px solid #1C9D0C;
    }

</style>
